import { HorseModel } from './HorseModel';
import { HorseInRaceTipsModel } from './HorseInRaceTipsModel';
import { TranslateService } from '@ngx-translate/core';
import { Video } from '../Video';
import { Util } from '../../util/Util';
import { ProAnalysisRace } from '../ProAnalysisRace';
export class HorseRaceModel{
   raceId: number;
   raceNum: number;
   raceName: string;
   raceDistance: string;
   raceDate: string;
   raceTime: string;
   raceCourse: string;
   raceClass: string;
   raceTrackCondition: string;
   raceTrack: string;
   horses: Array<HorseModel>;
   hasP: boolean;
   hasQ: boolean;
   hasQP: boolean;
   raceTips: Array<HorseInRaceTipsModel>;
   entryUrl: string;
   entryVideoLength: string;
   raceUrl: string;
   raceVideoLength: string;
   bannerUrl: string;
   userId: number;
   firstVideos: Array<Video>;
   raceVidoes: Array<Video>;
   code: number;
   isFav: boolean;
   alProAnalysisRace: Array<ProAnalysisRace>;
   hasEntryUrl: boolean;
   hasRaceUrl: boolean;
   hasArticle: boolean;
   startIdx:number;
   keyRace:boolean;

	constructor(raceId: number, raceNum: number, raceName: string, raceDistance: string, raceDate: string,
    raceTime: string, raceCourse: string, raceClass: string, raceTrack: string, raceTrackCondition: string,
    horses: Array<HorseModel>, hasP: boolean, hasQ: boolean, hasQP: boolean, raceTips: Array<HorseInRaceTipsModel>, keyrace:boolean,
    entryUrl?: string, raceUrl?: string, bannerUrl?: string, userId?: number, firstVideos?: Array<Video>, raceVidoes?: Array<Video>,
    code?: number, isFav?: boolean, startIdx?:number) {
      this.raceId = raceId;
      this.raceNum = raceNum;
      this.raceName = raceName;
      this.raceDistance = raceDistance;
      this.raceDate = raceDate;
      this.raceTime = raceTime;
      this.raceCourse = raceCourse;
      this.raceClass = raceClass;
      this.raceTrackCondition = raceTrackCondition;
      this.raceTrack = raceTrack;
      this.horses = horses;
      this.hasP = hasP;
      this.hasQ = hasQ;
      this.hasQP = hasQP;
      this.raceTips = raceTips;
      this.keyRace =  keyrace;
      this.startIdx = startIdx;
      if (entryUrl != null && entryUrl.indexOf("?") > 0) {
        let entryTemp = entryUrl.split("?");
        this.entryUrl = entryTemp[0];
        this.entryVideoLength = entryTemp[1];
      } else{
        this.entryUrl = entryUrl;
      }
      if (raceUrl != null && raceUrl.indexOf("?") > 0) {
        let raceTemp = raceUrl.split("?");
        this.raceUrl = raceTemp[0];
        this.raceVideoLength = raceTemp[1];
      } else{
        this.raceUrl = raceUrl;
      }
      this.bannerUrl = Util.getBanner(bannerUrl);
      this.userId = userId;
      this.firstVideos = firstVideos;
      this.raceVidoes = raceVidoes;
      this.code = code;
      this.isFav = isFav;
  }

  public static getDateNCourse(horseRaceModel:HorseRaceModel, translateService: TranslateService): string {
    return "<span class='boldFont'>" + horseRaceModel.raceDate + "</span> " + translateService.instant(horseRaceModel.raceCourse);
  }

  public static getContent(horseRaceModel:HorseRaceModel, translateService: TranslateService, isShowRaceDate:boolean, removeYear:boolean = false): string {
    let raceDistanceArray = translateService.instant(horseRaceModel.raceDistance).split(/([0-9]+)/);
    let content: string = "<span class='boldFont'>";
    if (isShowRaceDate) {
      content += removeYear ? Util.formatDateMonthDay(Util.createDateFromString(horseRaceModel.raceDate)) + " " : horseRaceModel.raceDate + " ";
    }
    // translateService.instant(horseRaceModel.raceCourse) + " " +
    content += horseRaceModel.raceTime + "</span> " + translateService.instant(horseRaceModel.raceClass) + " " 
        + raceDistanceArray[0] + "<span class='boldFont'>" +raceDistanceArray[1]
        + translateService.instant(horseRaceModel.raceTrack) + "</span> " + "<br />" + horseRaceModel.raceName;
    return content;
  }

}



// WEBPACK FOOTER //
// ./src/model/horse/HorseRaceModel.ts